/**
 * trDateTime.js — TR yerel (Europe/Istanbul, UTC+3, DST yok) "şimdi"
 * değerini form varsayılanları için ÜRETEN tek ortak yardımcı ailesi.
 *
 * KÖK NEDEN (Danışman CRM Faz 2, Chrome E2E bloker): `new Date().toISOString().slice(...)`
 * UTC duvar saatini üretir; bu değer sonradan naive TR-yerel bir alana
 * (datetime-local/date/month input varsayılanı, backend'e doğrudan
 * gönderilen alan) konursa gerçek TR saatinden 3 saat GERİDE görünür
 * (örn. tarayıcı 20:05 TR iken form 17:05 gösterip o değerle kaydeder).
 * 00:00–03:00 TR aralığında ayrıca TAKVİM GÜNÜ de bir önceki güne düşer.
 *
 * Backend'in services/tr_time.py'deki sabit +3 offset yaklaşımıyla
 * TUTARLIDIR ve tarayıcının/işletim sisteminin yerel saat dilimi
 * ayarına BAĞIMLI DEĞİLDİR — her zaman gerçek TR duvar saatini üretir.
 *
 * Yalnızca naive TR-yerel alanlara YAZILAN varsayılanlar için kullanılır;
 * sistem tarafından üretilmiş UTC offsetli değerleri (örn. created_at)
 * GÖSTEREN yerler bu modülü kullanmaz.
 */
const TR_OFFSET_MS = 3 * 60 * 60 * 1000;

function trNowParts() {
  const shifted = new Date(Date.now() + TR_OFFSET_MS);
  return {
    y: shifted.getUTCFullYear(),
    m: shifted.getUTCMonth() + 1,
    d: shifted.getUTCDate(),
    hh: shifted.getUTCHours(),
    mm: shifted.getUTCMinutes(),
  };
}

const pad = (n) => String(n).padStart(2, '0');

/** "YYYY-MM-DDTHH:MM" — <input type="datetime-local"> varsayılanı. */
export function trNowLocalInput() {
  const { y, m, d, hh, mm } = trNowParts();
  return `${y}-${pad(m)}-${pad(d)}T${pad(hh)}:${pad(mm)}`;
}

/** "YYYY-MM-DD" — <input type="date"> / TR takvim günü varsayılanı. */
export function trNowLocalDateInput() {
  const { y, m, d } = trNowParts();
  return `${y}-${pad(m)}-${pad(d)}`;
}

/** "YYYY-MM" — <input type="month"> / TR takvim ayı varsayılanı. */
export function trNowLocalMonthInput() {
  const { y, m } = trNowParts();
  return `${y}-${pad(m)}`;
}

/**
 * İŞ GÜNÜ hesabı — "ilk taksit maksimum 3 iş günü" kuralının arayüz ayağı.
 * 25 Ağustos 2026, Recep kararı.
 *
 * Backend'deki `services/tr_time.py::tr_add_business_days` ile AYNI mantık:
 * iş günü = Pazartesi–Cuma, başlangıç günü sayılmaz, resmî tatil hesaba
 * KATILMAZ (repoda tatil takvimi yok — bilinçli).
 *
 * ⚠️ Bu yalnızca bir arayüz kolaylığıdır (date input'un `max` değeri).
 * Gerçek kapı backend'de `validate_first_due_date_or_400` — burası
 * atlatılsa bile satış 400 döner. İkisi ayrı ayrı değiştirilirse sınır
 * kayar; birini güncelleyen diğerini de güncellemeli.
 */
export function trAddBusinessDays(dateStr, days) {
  const [y, m, d] = dateStr.split('-').map(Number);
  const cur = new Date(Date.UTC(y, m - 1, d));
  let kalan = days;
  while (kalan > 0) {
    cur.setUTCDate(cur.getUTCDate() + 1);
    const gun = cur.getUTCDay(); // 0=Pazar, 6=Cumartesi
    if (gun !== 0 && gun !== 6) kalan -= 1;
  }
  return cur.toISOString().slice(0, 10);
}

/** İlk taksit vadesi üst sınırı — backend sabitiyle (3) aynı olmalı. */
export const ILK_TAKSIT_MAX_IS_GUNU = 3;

/**
 * Kart çekim tarihi üst sınırı (TAKVİM günü, iş günü DEĞİL) — backend
 * sabitiyle (services/sales_service.py::KART_CEKIM_MAX_GUN) AYNI olmalı.
 *
 * 2026-09-27 fix: kart çekim tarihi "ilk taksit" değildir — öğrencinin/
 * danışmanın ekstre/limit döngüsüne göre seçtiği bir tarihtir,
 * ILK_TAKSIT_MAX_IS_GUNU (3 iş günü) kuralı ona uygulanmaz. Bu sabit
 * yalnızca arayüz kolaylığıdır (date input'un `max` değeri) — gerçek kapı
 * backend'de `validate_card_charge_date_or_400`.
 */
export const KART_CEKIM_MAX_GUN = 90;
